import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/zh';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { ESQUnit, ELanguage } from '@/types';

dayjs.extend(localizedFormat);
dayjs.extend(timezone);

export const isDev = import.meta.env.VITE_DEV === 'true';

export const LOCAL_TZ = dayjs.tz.guess();

export const DEFAULT_LANG = ELanguage.EN_US;

export const DEFAULT_ORG_LOGO_NAME = 'org_default';

export const DT_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const T_FORMAT = 'HH:mm';

export const FONT_FAMILY_PER_LANG = {
  [ELanguage.EN_US]: 'Averta',
  [ELanguage.ZH_HANS]: 'OpenSans',
};

export const SQ_METRIC_TO_UNIT_CONVERSION_FEE = {
  [ESQUnit.METRIC]: 1,
  [ESQUnit.INCH]: 1550,
  [ESQUnit.FEET]: 10.7639,
};

// Analytics sampling constants — shared with federated remotes
export {
  TRAFFIC_WINDOWS,
  OCCUPANCY_WINDOWS,
  TRAFFIC_MAX_DATA_COUNTS,
  OCCUPANCY_MAX_DATA_COUNTS,
  DETECTIONS_WINDOW,
} from '@butlrtechnologies/shared/constants/analytics';

export const DATE_TIME_FORMAT = {
  zh: {
    monthDate: 'MMMD日',
    hourMinute: 'Ah时mm分',
    hour: 'Ah时',
    fullDateTime: 'YYYY年MMMD日Ahh时mm分',
  },
  en: {
    monthDate: 'MMM D',
    hourMinute: 'h:mmA',
    hour: 'hA',
    fullDateTime: 'hh:mm A MMM D YYYY',
  },
};

export const DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_ISO8601_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';

export const ZERO_TIME = '0001-01-01T00:00:00Z';

// Shorthand display names for hive models (e.g., 'hive1' => 'H1')
export const HIVE_MODEL_SHORT_NAME: Record<string, string> = {
  hive1: 'H1',
  hive1c: 'H1C',
  'hive1c+': 'H1C+',
  hive2: 'H2',
  hive3: 'H3',
};
